import script from "./curriculumPage.vue?vue&type=script&setup=true&lang=js"
export * from "./curriculumPage.vue?vue&type=script&setup=true&lang=js"

import "./curriculumPage.vue?vue&type=style&index=0&id=28a7e55c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a7e55c"]])

export default __exports__